const SearchSelector = {
  install: (Vue) => {
    Vue.component('SearchSelector', () => {
      return import('./components/index.vue')
    })
  }
}

export default SearchSelector
